export default "__VITE_ASSET__DfMteovn__"